/**
 *
 * TextArea Component
 *
 */

import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React from 'react';

import useStyles from './styles';

/**
 *  @deprecated
 *  @example
 *
 *  Use `@material-ui/core/TextField` instead.
 *
 *  ```
 *  <TextField value="Words" onChange={onChange} />
 *  ```
 */
const TextArea = ({
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  'aria-describedby': ariaDescribedBy,
  inputProps,
  ...props
}) => {
  const classes = useStyles();
  return (
    <TextField
      className={classes.textfield}
      InputProps={{
        classes: {
          root: classes.inputRoot,
        },
      }}
      multiline
      variant="outlined"
      {...props}
      inputProps={{
        ...inputProps,
        'aria-label': ariaLabel ?? inputProps?.['aria-label'],
        'aria-labelledby': ariaLabelledBy ?? inputProps?.['aria-labelledby'],
        'aria-describedby': ariaDescribedBy ?? inputProps?.['aria-describedby'],
      }}
    />
  );
};

TextArea.propTypes = {
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  'aria-describedby': PropTypes.string,
  inputProps: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default TextArea;
